import { routeMapping } from "../../route.config";

export const getListDetailsPath = (listId: string) => {
    const { path } = routeMapping.searchList;
    return path.replace(":listId", listId);
};
